let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("86bl6")).then(() => parcelRequire('hlJ0R'));